import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { BidderMailingListReportContainer } from "../components/reporting/BidderMailingListReportContainer";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

const BidderMailingListReporting = () => (
  <Container maxWidth={"lg"} fixed>
    <SecureArea memberPermission={MemberPermission.AccountAdmin}>
      <Typography variant="h4" color="primary" gutterBottom>
        Bidder Mailing List Reports
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Create an export for bidder mailing list reports
      </Typography>
      <Box mt={4}>
        <BidderMailingListReportContainer />
      </Box>
    </SecureArea>
  </Container>
);

export default withAITracking(reactPlugin, BidderMailingListReporting, "BidderMailingListReporting");
